import React, { useEffect, useState } from 'react';

const SearchDropdownList = (props) => {
  const [filteredItems, setFilteredItems] = useState([]);

  useEffect(() => {
    if (props.country && props.country !== '0') {
      const filtered = props.items.filter(item => item.country_id === props.country);
      setFilteredItems(filtered);
    } else {
      setFilteredItems(props.items);
    }
  }, [props.country, props.items]);

  return (
    <div className="popup-body fixed">
      {filteredItems.map((item) => renderItems(item, props))}
    </div>
  );
};

const renderItems = (item, props) => {
  const isSelected = item.id === Number(props?.value);

  return (
    <p
      key={item.id}
      title={item.id}
      className={`clickable dropdown-list__item ${isSelected ? 'dropdown-list__item_selected' : ''}`}
      onClick={() => props.onChoose(item.id)}
    >
      {item.name}
    </p>
  );
};

export default SearchDropdownList;
